import { Runnable } from 'src/services/runtime/runnable';
import * as QA from 'shared/utils/queryAnalysis';


const Data = {
  BorderFormat: { weight: 'Thin', color: '#000000' },
};


export class ConvertIds extends Runnable {
  constructor(selection, meta, parent = null) {
    super(meta, parent);

    const { addresses, worksheetId } = selection;
    this.addresses = addresses;
    this.worksheetId = worksheetId;
    this.worksheet = this.context.workbook.worksheets.getItem(worksheetId);
  }

  get name() { return 'Convert IDs'; }

  async _run_() {
    const ranges = this.addresses.map(rangeAddress => {
      return this.worksheet.getRange(rangeAddress.shortAddress).load(['values']);
    });

    await this.sync();

    let counter = 0;
    ranges.forEach(range => {
      let rangeCounter = 0;
      
      const values = range.values.map(row => {
        return row.map(value => {
          if (QA.isOldFormatSalesforceId(value)) {
            rangeCounter += 1;
            return QA.convertOldFormatId(value);
          }
          return value;
        });
      });

      if (rangeCounter) {
        range.values = values;
      }

      counter += rangeCounter;
    });

    if (counter) {
      await this.sync();
    }

    return { convertedCount: counter };
  }

  async _createLogger_() {
    const ws = this.worksheet.load(['id', 'name']);
    await this.sync();

    const props = {
      worksheetName: ws.name,
      name: `Convert ids at '${ws.name}'`,
      borderFormat: Data.BorderFormat,
    };

    super.createLogger(props);
  }
}


export default ConvertIds;